module.exports = __webpack_public_path__ + "static/media/fi.e8d0bd77.svg";